import { TextInput } from '../baseInputs'

type Props = {
  helper?: string
  name?: string
  label?: string
}

const LastName = ({ helper, name, label, ...rest }: Props) => {
  return (
    <TextInput
      name={name || 'last_name'}
      label={label || 'Last name'}
      helper={helper}
      {...rest}
    />
  )
}

export default LastName
